import { Component, Input, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { StandardUIService } from '../services/standardui-service/standardui-service';
import { AgentscriptService_updated } from '../services/agent-script-service/agent-script-service';
import { AgentscriptService } from '../services/agentscript-services/agentscript.service';
import { BsDatepickerDirective } from 'ngx-bootstrap/datepicker';
import Swal from 'sweetalert2/dist/sweetalert2.js';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { ObjectController } from '../services/object-controller/objectcontroller.service';


@Component({
  selector: 'app-newanswer',
  templateUrl: './newanswer.component.html',
  styleUrls: ['./newanswer.component.scss'],
})
export class NewanswerComponent {
  tcontainer = {
    height: $(window).height() - $('.layout-navbar').height() - 230 + 'px',
    overflow: 'hidden',
    'overflow-y': 'auto',
  };
  @Input() componentContext;
  answerform: FormGroup;
  casetypeVal: any = [];
  departmentVal: any = [];
  departmentDropdownSettings = {};
  casetypeDropdownSettings = {};
  selectedDepartments: any;
  type: any = [];
  answerstatus: any = [];
  accessid: any = [];
  assignedgroup: any = [];
  associatedarea: any = [];
  language: any = [];
  answertype: any = [];
  isAdmin: boolean = false;
  @ViewChild('froalaRef') froalaRef: any;

  public editorOptions: Object = {
    key: 'sZH1rB3A5B6D5G4E4iAa1Tb1YZNYAh1CUKUEQOHFVANUqD1G1F4A3B1C8E7D2C4F3==',
    // charCounterCount: true,
    charCounterCount: false, // Set to false to disable character count
    // charCounterMax: 35000,
    // immediateAngularModelUpdate: true,
    charCounterMax: -1,                // Don't block input
    immediateAngularModelUpdate: true,
  };

  updateEditorCounter() {
  const editorInstance = this.froalaRef?.editor;

  if (editorInstance) {
    const html = editorInstance.html.get();
    const count = html.length;
    const counter = editorInstance.$box.find('.fr-custom-counter');

    counter.html(`HTML characters: ${count}/35000`);
  }
}

  constructor(
    private fb: FormBuilder,
    private _standardUiService: StandardUIService,
    private agentscript: AgentscriptService,
    private sanitizer: DomSanitizer,
    private agentscriptservice_updated:AgentscriptService_updated,
    private objectcontrolservice:ObjectController
  ) {}
  newanswer:any
  deleteanswer:any

  convertToEST(data) {
    //EST
    //let offset = -4.00;
    let clientDate = new Date(data);
    //let utc = clientDate.getTime() + (clientDate.getTimezoneOffset() * 60000);
    //let serverDate = new Date(utc + (3600000*offset));
    return clientDate.toLocaleString('en-US', { hour12: true });
  }

  ngOnInit() {
    this.deleteanswer=false;
    this.answerform = this.fb.group({
      description: ['', [Validators.required, Validators.maxLength(8000)]],
      summary: ['', [Validators.required, Validators.maxLength(550)]],
      answertype: [''],
      accessid: [''],
      associatedarea: [''],
      assigngroupid: [''],
      statusid: [''],
      languageid: [''],
      createdtime: [''],
      updatedtime: [''],
      publishon: [''],
      departmentid: [[], [Validators.required]],
      categoryid: [[], [Validators.required]],
      type: [1],
      keywords: ['', [Validators.required, Validators.maxLength(8000)]],
      solution: ['',[ Validators.maxLength(50000)]],
      // solution: ['',[ Validators.maxLength(10000)]],
      url: [''],
    });
    this.picklist();
    this.departmentDropdownSettings = {
      singleSelection: false,
      idField: 'id',
      textField: 'value',
      selectAllText: 'Select All',
      unSelectAllText: 'Unselect All',
      itemsShowLimit: 5,
      allowSearchFilter: true,
      // disabled:true
    };

    this.casetypeDropdownSettings = {
      singleSelection: false,
      idField: 'id',
      textField: 'value',
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      itemsShowLimit: 5,
      allowSearchFilter: true,
    };
    this.answerform.get('type').valueChanges.subscribe((value) => {
      if (value === 2) {
        // If switching to value 2 (URL)
        // this.answerform.get('solution').reset(); // Reset 'solution' form control
      }
      if (value === 1) {
        // this.answerform.get('url').reset();
        // this.iframeUrl = ''; // Reset 'solution' form control
      }
    });
    this.answerform.get('type').valueChanges.subscribe((type) => {
      this.updateValidators(type);
    });

    // Initial call to set validators based on default type value
    this.updateValidators(this.answerform.get('type').value);
    // this.newanswerdate();
    console.log("componentContext",this.componentContext);
    this.newanswer=false
    if(this.componentContext && this.componentContext.id != null && this.componentContext.id=="newanswer" && this.componentContext.name == "New Answer")
    {
      this.newanswer = true;
    }
    console.log(typeof this.componentContext.id)
    console.log(this.answerform.value)
    if(typeof this.componentContext.id === 'number')
    {
      this.initialFormValues = this.answerform.value;
      console.log(this.initialFormValues)
      console.log(this.previousanswer)
      this.newanswerdata();
    }

  }
  initialFormValues: any;
  answerOptions: { id: string; value: string }[] = [];
  role:any;
  newanswerdata() {
    this.agentscript.getnewanswer(this.componentContext.id).subscribe((data: any) => {
      console.log(data);
this.previousanswer=data.payLoad;
      // Extract and de-duplicate department IDs
      const departmentIds = Array.from(
        new Map(
          data.payLoad.prodcat.map((item: any) => [item.departmentId, { id: item.departmentId, value: item.departmentName }])
        ).values()
      );

      // Extract and de-duplicate category names
      const categoryname = Array.from(
        new Map(
          data.payLoad.prodcat.map((item: any) => [item.categoryId, { id: item.categoryId, value: item.categoryName }])
        ).values()
      );

      // Safely convert publishon timestamp to date, or set it as an empty string if invalid
      const publishOnDate = data?.payLoad?.publishon ? new Date(data.payLoad.publishon) : null;
      const formattedPublishOn = publishOnDate ? publishOnDate.toISOString().split('T')[0] : '';

      // Safely convert createdtime timestamp to 'yyyy-MM-ddTHH:mm', or set as an empty string if invalid
      const createdDate = data?.payLoad?.createdtime ? new Date(data.payLoad.createdtime) : null;
      // const formattedCreatedTime = createdDate ? createdDate.toISOString().slice(0, 16) : '';
      const formattedCreatedTime = createdDate ? this.convertToEST(createdDate):'';


      // Safely convert updatedtime timestamp to 'yyyy-MM-ddTHH:mm', or set as an empty string if invalid
      const updatedDate = data?.payLoad?.updatedtime ? new Date(data.payLoad.updatedtime) : null;
      // const formattedUpdatedTime = updatedDate ? updatedDate.toISOString().slice(0, 16) : '';
      const formattedUpdatedTime = updatedDate ? this.convertToEST(updatedDate) : '';


      // Log values to check


this.role=localStorage.getItem('role');
console.log(this.role);
const accessId = data?.payLoad?.accessidpicklist?.id || '';
if (this.role !== 'Admin' && this.role!='CSS with KB') {

this.isAdmin=true;

  // console.log(this.departmentDropdownSettings)
  this.answerform.disable(); // Disable all form controls if admin
}
      // Set values in the form
      this.answerform.get('description')?.setValue(data.payLoad.description);
      this.answerform.get('summary')?.setValue(data.payLoad.summary);
      this.answerform.get('keywords')?.setValue(data.payLoad.keywords);
      this.answerform.get('solution')?.setValue(data.payLoad.solution);
      this.answerform.get('answertype')?.setValue(data.payLoad.answertype);
      this.answerform.get('accessid')?.setValue(accessId);
      this.answerform.get('associatedarea')?.setValue(data.payLoad.associatedarea);
      this.answerform.get('assigngroupid')?.setValue(data.payLoad.assigngroupid);
      this.answerform.get('statusid')?.setValue(data.payLoad.statusid);
      this.answerform.get('languageid')?.setValue(data.payLoad.languageid);
      this.answerform.get('publishon')?.setValue(formattedPublishOn);
      this.answerform.get('createdtime')?.setValue(formattedCreatedTime);
      this.answerform.get('updatedtime')?.setValue(formattedUpdatedTime);
      this.answerform.get('departmentid')?.setValue(departmentIds);
      this.answerform.get('categoryid')?.setValue(categoryname);
      this.answerform.get('type')?.setValue(data.payLoad.type);
      this.answerform.get('url')?.setValue(data.payLoad.url);

      const htmlContent = data.payLoad.solution || ''; // Fallback to empty string if solution is null
      setTimeout(() => {
    const editorInstance = this.froalaRef?.editor;

    if (editorInstance) {
      // ✅ Set the HTML manually
      editorInstance.html.set(htmlContent);

      // ✅ Manually update the custom counter
      const count = htmlContent.length;
      const counter = editorInstance.$box.find('.fr-custom-counter');

      counter.html(`HTML characters: ${count}/35000`);
      counter.css('color', count > 34000 ? 'red' : '#888');
    }
  }, 100); // Adjust delay if needed
});

  }
  deleteTheAnswer()
  {
    Swal.fire({
      title: '<div class="popup-content"><div class="popup-text"><img src="../../assets/images/warning.svg" class="animated-check">Delete Answer</div></div>',
      imageUrl: "https://fortwayne-portal.thesmartcity311.com/assets/images/fortwayne-logo-agent.svg",
      imageHeight: 45,
      showCloseButton: true,
      html: "Are you Sure?",
      type: 'Success',
      showCancelButton: true,
      confirmButtonText: 'OK',
      cancelButtonText: 'Cancel'
    }).then((result) => {
      if (result.value) {
        this.deleteanswer=true
        this.submitForm();
      }
      else
      {
        this.deleteanswer=false;
      }
    });
  }

  ngAfterViewInit() {
    if(typeof this.componentContext.id === 'number')
      {
        this.newanswerdata();
      }  // Call the function here if view needs to be initialized first
  }

  updateIframeUrl(): void {
    if (this.searchTerm) {
      // Sanitize the URL directly and update iframeUrl
      this.iframeUrl = this.sanitizer.bypassSecurityTrustResourceUrl(this.searchTerm);
    } else {
      // Clear the iframe URL if no searchTerm
      this.iframeUrl = null;
    }
  }
  updateValidators(type: number) {
    const solutionControl = this.answerform.get('solution');
    const urlControl = this.answerform.get('url');

    if (type === 1) {
      solutionControl.setValidators([Validators.required]);
      urlControl.clearValidators();
    } else if (type === 2) {
      urlControl.setValidators([Validators.required]);
      solutionControl.clearValidators();
    }

    solutionControl.updateValueAndValidity();
    urlControl.updateValueAndValidity();
  }

  onAnswerTypeChange(selectedValue: string) {
    const selectedOption = this.answerOptions.find(
      (option) => option.id === selectedValue
    );
    if (selectedOption) {
      console.log(selectedOption.value); // Display the selected answer value
    }
  }

  picklist() {
    const picklistIDs = [110, 20, 107, 139, 116, 113, 121, 108, 117]; // Array of picklist IDs
    picklistIDs.forEach((picklistID) => {
      this._standardUiService.getPicklistByID(picklistID).subscribe((data) => {
        // console.log(data)
        const picklistValues = [];
        for (let key in data) {
          if (data[key].active === true || data[key].active === '') {
            picklistValues.push({
              id: data[key].id,
              value: data[key].valueen,
            });
          }
        }
        if (picklistID == 110) {
          this.casetypeVal.push(...picklistValues);
          this.casetypeVal = picklistValues.map((item) => ({
            id: item.id,
            value: item.value,
          }));
          // console.log(this.casetypeVal);
        } else if (picklistID == 20) {
          this.departmentVal.push(...picklistValues);
          this.departmentVal = picklistValues.map((item) => ({
            id: item.id,
            value: item.value,
          }));

          console.log(this.departmentVal);
        } else if (picklistID == 107) {
          this.type.push(...picklistValues);
          this.type = picklistValues.map((item) => ({
            id: item.id,
            value: item.value,
          }));

          console.log(this.type);
        } else if (picklistID == 139) {
          this.answerstatus.push(...picklistValues);
          this.answerstatus = picklistValues.map((item) => ({
            id: item.id,
            value: item.value,
          }));

          console.log(this.answerstatus);
        } else if (picklistID == 116) {
          this.accessid.push(...picklistValues);
          this.accessid = picklistValues.map((item) => ({
            id: item.id,
            value: item.value,
          }));

          console.log(this.accessid);
        } else if (picklistID == 113) {
          this.assignedgroup.push(...picklistValues);
          this.assignedgroup = picklistValues.map((item) => ({
            id: item.id,
            value: item.value,
          }));

          console.log(this.assignedgroup);
        } else if (picklistID == 121) {
          this.language.push(...picklistValues);
          this.language = picklistValues.map((item) => ({
            id: item.id,
            value: item.value,
          }));

          console.log(this.language);
        } else if (picklistID == 108) {
          this.associatedarea.push(...picklistValues);
          this.associatedarea = picklistValues.map((item) => ({
            id: item.id,
            value: item.value,
          }));

          // console.log(this.associatedarea);
        } else if (picklistID == 117) {
          this.answertype.push(...picklistValues);
          this.answertype = picklistValues.filter((item) => (
           item.value === "HTML" || item.value === "URL"
          ));

          console.log(this.answertype);
        //   const filteredValues = picklistValues.filter(item =>
        //     item.value === "HTML" || item.value === "URL"
        // );

        // Update answertype with the filtered values
        // this.answertype = filteredValues.map(item => ({
        //     id: item.id,
        //     value: item.value
        // }));

        // console.log(this.answertype);
        }
      });
    });
  }
  @ViewChild('dp') datepicker: BsDatepickerDirective;
  searchTerm: string = '';
  iframeUrl: SafeResourceUrl = '';
  url: any;

  search(event: Event) {
    let searchTerm = this.searchTerm.trim().toLowerCase(); // Trim and convert to lowercase
    // Check if the searchTerm already starts with http://, https://, or www.
    if (
      searchTerm.startsWith('http://') ||
      searchTerm.startsWith('https://') ||
      searchTerm.startsWith('www.') ||
      searchTerm.startsWith('https://www.')
    ) {
      if (searchTerm.startsWith('https://www.')) {
        searchTerm = searchTerm.substring('https://www.'.length);
        this.url = `https://www.${encodeURIComponent(searchTerm)}`;
        $('.pane:visible .dt-search input')
          .val(searchTerm)
          .keyup()
          .trigger(jQuery.Event('keypress', { which: 13 }));
        this.iframeUrl = this.sanitizer.bypassSecurityTrustResourceUrl(
          this.url
        );
      } else if (searchTerm.startsWith('http://')) {
        searchTerm = searchTerm.substring('http://'.length);
        this.url = `https://www.${encodeURIComponent(searchTerm)}`;
        $('.pane:visible .dt-search input')
          .val(searchTerm)
          .keyup()
          .trigger(jQuery.Event('keypress', { which: 13 }));
        this.iframeUrl = this.sanitizer.bypassSecurityTrustResourceUrl(
          this.url
        );
      } else if (searchTerm.startsWith('https://')) {
        searchTerm = searchTerm.substring('https://'.length);
        this.url = `https://www.${encodeURIComponent(searchTerm)}`;
        $('.pane:visible .dt-search input')
          .val(searchTerm)
          .keyup()
          .trigger(jQuery.Event('keypress', { which: 13 }));
        this.iframeUrl = this.sanitizer.bypassSecurityTrustResourceUrl(
          this.url
        );
      } else if (searchTerm.startsWith('www.')) {
        searchTerm = searchTerm.substring('www.'.length);
        this.url = `https://www.${encodeURIComponent(searchTerm)}`;
        $('.pane:visible .dt-search input')
          .val(searchTerm)
          .keyup()
          .trigger(jQuery.Event('keypress', { which: 13 }));
        this.iframeUrl = this.sanitizer.bypassSecurityTrustResourceUrl(
          this.url
        );
      }
    } else {
      // Directly use the searchTerm if it already contains http://, https://, or www.
      console.log(
        'Search term already contains http/https/www., skipping URL construction.'
      );
      this.url = `https://www.${encodeURIComponent(searchTerm)}`;
      $('.pane:visible .dt-search input').val(searchTerm).keyup();
      this.iframeUrl = this.sanitizer.bypassSecurityTrustResourceUrl(this.url);
    }
  }

  clearsearch() {
    this.searchTerm = '';
  }
  openDatepicker() {
    this.datepicker.show();
  }
  updateZeroValuesToNull(formData: any, fields: string[]): void {
    fields.forEach(field => {
      if (formData[field] === 0||Number.isNaN(formData[field])) {
        formData[field] = null;
      }
      if(formData[field] === "")
      {
        console.log("in second if")
        formData[field] = "";
      }
    });
  }
saveanswer(formData:any)
{
  this.deleteanswer=false;
  this.agentscript.saveanswer(formData).subscribe((data: any) => {
    console.log(data);
    if (data) {
      
    Swal.fire({
      title:
        '<div class="popup-content"><div class="popup-text"> <img src="../../assets/images/verified.svg" class="animated-check" >Submitted successfully</div></div>',
      icon: 'error',
      imageUrl: "https://fortwayne-portal.thesmartcity311.com/assets/images/fortwayne-logo-agent.svg",
      imageHeight: 45,
      showCloseButton: true,
      showCancelButton: false,
      focusConfirm: false,
      confirmButtonText: `OK`,
      cancelButtonText: 'Cancel',
    });

    $('li.active .tab-close').trigger('click');
    $("[data-obj-id='" + 'home' + "']").parent().trigger('click');

      const saveAgentRecentAccesspayload = { answerid: data };
      this._standardUiService
        .saveAgentRecentAccess(saveAgentRecentAccesspayload)
        .subscribe((data: any) => {
          console.log(data);
          this.agentscriptservice_updated.agentrecentaccess();
          this.agentscriptservice_updated.refreshcitizenportalanswers();
          this.agentscriptservice_updated.refreshanswers();
        });
    }
    else {
        Swal.fire({
          title: '<div class="popup-content"><div class="popup-text"><img src="../../assets/images/warning.svg" class="animated-check">Answer cannot be saved at the moment. Please try again later</div></div>',
          icon: 'error',
          imageUrl: "https://fortwayne-portal.thesmartcity311.com/assets/images/fortwayne-logo-agent.svg",
          imageHeight: 45,
          showCloseButton: true,
          showCancelButton: false,
          focusConfirm: false,
          confirmButtonText: 'OK',
          cancelButtonText: 'Cancel',
        })
    }
  });
}
previousanswer:any;
  submitForm() {

    // if (this.deleteanswer) {
    //   let formData = {}
    //   formData = { 'active': false, 'id': this.componentContext.id };
    //   this.saveanswer(formData);
    //   return;
    // }

    if (this.answerform.valid) {
      let formData = { ...this.answerform.value }; // Copy the form value
      console.log(this.url);
      console.log(this.componentContext.id)
      console.log(this.answerform.get('publishon').value)

      let publishOnValue = this.answerform.get('publishon').value;
      let publisheddate = Date.parse(publishOnValue); // Get timestamp in milliseconds
      let createdtime = Date.parse(this.answerform.get('createdtime').value);
      let updatedtime = Date.parse(this.answerform.get('updatedtime').value);


      // Mapping IDs to required fields
      formData.departmentid = this.answerform.get('departmentid').value.map((option) => option.id);
      formData.categoryid = this.answerform.get('categoryid').value.map((option) => option.id);
      formData.answertype = Number(this.answerform.get('answertype').value);
      formData.accessid = Number(this.answerform.get('accessid').value);
      formData.associatedarea = Number(this.answerform.get('associatedarea').value);
      formData.assigngroupid = Number(this.answerform.get('assigngroupid').value);
      formData.statusid = Number(this.answerform.get('statusid').value);
      formData.languageid = Number(this.answerform.get('languageid').value);
      formData.type = Number(this.answerform.get('type').value);

      formData.publishon = isNaN(publisheddate) ? null : publisheddate;
      // not updating created and updated time
      // formData.createdtime = isNaN(createdtime) ? null : createdtime;
      // formData.updatedtime = isNaN(updatedtime) ? null : updatedtime;
      formData.active = !this.deleteanswer;
      if (typeof this.componentContext.id === 'number') {
        formData.id = this.componentContext.id;
      }

      // Handle form based on type
      if (formData.type === 1) {
        formData.solution = this.answerform.get('solution').value;
        delete formData.url;
      } else if (formData.type === 2) {
        formData.url = this.url;
        delete formData.solution;
      }

      const fieldsToCheck = ['accessid', 'assigngroupid', 'answertype', 'associatedarea', 'statusid', 'languageid', 'type', 'publishon', 'createdtime', 'updatedtime'];

      // Update zero values to null dynamically
      this.updateZeroValuesToNull(formData, fieldsToCheck);

      // Filter out fields that are null or empty
      Object.keys(formData).forEach(key => {
        if (formData[key] === null) {
          delete formData[key];
        }
      });
      console.log(this.previousanswer)
      console.log(formData);
      this.saveanswer(formData);

    }

    else {
      console.log('Form is invalid');
    }
  }

}
